
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { permitCountry } from "@common/src/utils/tools";
const base = namespace("base");

@Component({
  model: {
    prop: "methodList",
    event: "change"
  }
})
export default class NoticeChannel extends Vue {
  @base.Action getDictionaryList;
  @base.Action queryStoreMessageBalance;
  @base.State msmBalance;
  @Prop({})
  methodList: any;
  @Prop({ default: () => [], type: Array })
  defaultChannel: any;
  @Prop({ default: false, type: Boolean })
  onlyWeixin: any;
  @Prop({ default: false, type: Boolean })
  showInsideMsg: boolean;
  @Prop({ default: "1", type: String }) // "1" | "2"
  layout: string;
  @Prop({ default: "", type: String })
  smsPreview: string;
  @Prop({ default: () => [], type: Array })
  disableItems: any;
  permitCountry = permitCountry;
  created() {
    this.init();
  }
  noticeMethodList = [];
  // msmBalance: number | string = "";
  init() {
    const key = this.showInsideMsg ? "notify_method_inventory_alert" : "notify_method";
    this.getDictionaryList(key).then(data => {
      this.noticeMethodList = data.map(item => {
        if (this.defaultChannel && this.defaultChannel.includes(item.value)) {
          item.checked = true;
        } else {
          item.checked = false;
        }
        return item;
      });
      this.handleMethodChange();
    });
    this.queryStoreMessageBalance().then(() => {
      //
    });
  }
  handleMethodChange() {
    let checkItem = this.noticeMethodList.filter(item => item.checked).map(item => item.value);
    this.$emit("change", checkItem);
  }

  @Watch("defaultChannel")
  watchDefaultChannel(val) {
    if (!this.noticeMethodList.length) {
      return;
    }
    const checkItem = [];
    this.noticeMethodList.forEach(method => {
      if (val.includes(method.value)) {
        method.checked = true;
        checkItem.push(method.value);
      } else {
        method.checked = false;
      }
    });
    this.$emit("change", checkItem);
  }
  @Watch("methodList")
  watchMethodList(val) {
    this.noticeMethodList.forEach(method => {
      if (val.includes(method.value)) {
        method.checked = true;
      } else {
        method.checked = false;
      }
    });
  }
}
